import { createContext, useContext } from 'react';

/**
 * True while a route transition has STARTED but its destination has not
 * committed yet.
 *
 * This is the state `v7_startTransition` produces and keeps to itself. React 18
 * holds the previous page on screen when an update inside a transition
 * suspends, so a navigation to a route whose lazy chunk is still loading moves
 * the URL and changes nothing else — and nothing rendered *inside* `<Routes>`
 * can notice, because the suspended update blocks that whole subtree
 * (`useLocation()` does not advance either). The pending flag therefore has to
 * come from the component that owns the transition: `TransitionRouter`.
 *
 * Defaults to `false`, so a component rendered outside the app router — a unit
 * test wrapping itself in a plain `BrowserRouter`, for instance — simply never
 * reports pending instead of blowing up.
 */
export const RoutePendingContext = createContext(false);

/** @see RoutePendingContext */
export function useRoutePending(): boolean {
  return useContext(RoutePendingContext);
}
